import RequestAbstract from "./RequestAbstract";

export default class PriceLists extends RequestAbstract {
    get link() {
        return this.links.priceLists;
    }

    getAllPriceLists() {
        return this.getAllFiltered([[]], this.getSortField("-dateFrom"));
    }

    async getPriceListsExtendet() {
        const res = await this.get(this.link);
        return res;
    }
}
